import { render, staticRenderFns } from "./reportDetailMore.vue?vue&type=template&id=15401b62&scoped=true"
import script from "./reportDetailMore.vue?vue&type=script&lang=js"
export * from "./reportDetailMore.vue?vue&type=script&lang=js"
import style0 from "./reportDetailMore.vue?vue&type=style&index=0&id=15401b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15401b62",
  null
  
)

export default component.exports